import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const cat = categories.find((c) => c.slug === pathSegments[1]);
    breadcrumbs.push({
      label: cat ? cat.name : pathSegments[1],
      path: `/category/${pathSegments[1]}`,
    });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    breadcrumbs.push({ label: '影片详情', path: undefined });
  } else if (pathSegments[0] === 'about') {
    breadcrumbs.push({ label: '关于我们', path: '/about' });
  }

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 pt-20 pb-2">
      <div className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {breadcrumbs.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="text-foreground-300">/</span>
            )}
            {item.path ? (
              <Link
                to={item.path}
                className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </div>
    </nav>
  );
}